import { render } from "./IndexFacture.vue?vue&type=template&id=1d129975&scoped=true"
import script from "./IndexFacture.vue?vue&type=script&lang=js"
export * from "./IndexFacture.vue?vue&type=script&lang=js"

import "./IndexFacture.vue?vue&type=style&index=0&id=1d129975&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d129975"]])

export default __exports__